// extracted by mini-css-extract-plugin
export default {"card":"Unit_card__p80nN","box":"Unit_box__-INwv","content":"Unit_content__1BKsu"};